import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { AppCheckbox } from './Checkbox';
import { BodyXS } from './Typography';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** The consent copy; also the checkbox's accessible name. */
  label: string;
  testId: string;
  /** Rendered under the label, e.g. a "show full text" expander. */
  children?: ReactNode;
};

/** Round checkbox with long consent copy beside it, shared by the coverage screens. */
export const ConsentCheckbox: FunctionComponent<Props> = (props) => (
  <ConsentRow>
    <AppCheckbox
      checked={props.checked}
      onChange={({ target: { checked } }) => props.onChange(checked)}
      data-testid={props.testId}
      aria-label={props.label}
    />
    <ConsentBody>
      <ConsentText
        onClick={() => props.onChange(!props.checked)}
        data-testid={`${props.testId}-label`}
      >
        {props.label}
      </ConsentText>
      {props.children}
    </ConsentBody>
  </ConsentRow>
);

const ConsentRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing._16px};
  margin-top: ${({ theme }) => theme.spacing._16px};
  /* AppCheckbox is scaled up; give it room so it doesn't overlap the first line of text. */
  padding-left: ${({ theme }) => theme.spacing._8px};
`;

const ConsentBody = styled.div`
  flex: 1;
`;

const ConsentText = styled(BodyXS)`
  text-align: left;
  margin: 0;
  cursor: pointer;
`;
